import { render } from "./CustomerCreateTicket.vue?vue&type=template&id=ac50f326&scoped=true"
import script from "./CustomerCreateTicket.vue?vue&type=script&lang=js"
export * from "./CustomerCreateTicket.vue?vue&type=script&lang=js"

import "./CustomerCreateTicket.vue?vue&type=style&index=0&id=ac50f326&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac50f326"]])

export default __exports__